import { Component, Input, OnInit } from '@angular/core';
import { ISolicitudVehiculoModel } from 'src/app/models/interfaces/solicitud/ISolicitudVehiculoModel';
import { VehiculoModel } from 'src/app/models/solicitud/VehiculoModel';

@Component({
  selector: 'app-vehiculo-form',
  templateUrl: './vehiculo-form.component.html',
  styleUrls: ['./vehiculo-form.component.css']
})
export class VehiculoFormComponent implements OnInit {
  @Input() vehiculo: ISolicitudVehiculoModel;
  @Input() disabled: boolean = false;
  
  constructor() { 
    this.vehiculo = new VehiculoModel();
  }

  ngOnInit(): void {
  }

}
